exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".addEditGiftDialog {\n  max-width: 400px !important; }\n  .addEditGiftDialog .list-item {\n    margin-top: 15px; }\n  .addEditGiftDialog .select-type {\n    margin-bottom: 10px; }\n\n.name-price {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between; }\n  .name-price div:first-child {\n    -ms-flex-preferred-size: 48%;\n    flex-basis: 48%; }\n\n.giftImage {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/gifts/AddEditItem/AddEditItem.scss
// module id = 1699
// module chunks = 0